import { LogglyTracker } from 'loggly-jslogger';

const logger = new LogglyTracker();

logger.push({ 'logglyKey': '1eXsBJNhQ84kYPECd7WBmgEkC-k4kEs_OLD3KNKu18g8IuFONB2Ab6qZTwa80Dv2AHQ7SRM' });

export default logger;